import {
    Accordion,
    IAccordionProperties,
} from '@vfde-brix/ws10/accordion';
import { footnoteAccordion } from '../../components/accordion';
import { ContentId } from '../../enums/elementId';

/**
 * Returns the index of the tariff footnote item, or null if not found.
 */
export const getTariffFoonoteItemIndex = () => {
    if (!footnoteAccordion) {
        return null;
    }

    const { items } = footnoteAccordion.getProperties();
    const index = items.findIndex(item => item.stdId === ContentId.TariffFootnoteAccordionItem);

    return (index < 0) ? null : index;
};

/**
 * Returns an accordion item props with the given content text
 */
export const getUpdatedAccordionItemProps = (
    accordion: Accordion,
    itemIndex: number,
    newContent: string,
): Partial<IAccordionProperties> => {
    const props = accordion.getProperties();
    const item = props.items[itemIndex];

    if (!item) {
        return {};
    }

    item.containerAnyComponent = newContent;

    return props;
};
